import { WizardShell } from './wizard/wizard-shell';

export function BudgetPage() {
  return <WizardShell />;
}
